import useScrollAnimation from './useScrollAnimation'
import { Container, Grid, Box, Typography } from '@mui/material'

const KeyFeatures = () => {
  useScrollAnimation('.feature-box') // Targets the elements in this section

  const features = [
    {
      icon: '/assets/document-templates/key-features1.svg',
      title: 'Centralized Platform',
      description:
        'Unify your data into a single, integrated system. Eliminate scattered tools and disconnected workflows with centralized access that drives clarity, control, and confident decision-making across your entire organization.',
    },
    {
      icon: '/assets/document-templates/key-features2.svg',
      title: 'Streamlined Workflows & Collaboration',
      description:
        'Boost productivity with optimized workflows and enhanced team communication. Collaborate effortlessly across departments with tools designed to align and accelerate your operations.',
    },
    {
      icon: '/assets/document-templates/key-features3.svg',
      title: 'Real-Time Analytics & Dashboards',
      description:
        'Experience the power of real-time analytics through elegant, personalized dashboards—whether you need high-level overviews or deep data dives, every view is designed to deliver insights exactly how you want.',
    },
    {
      icon: '/assets/document-templates/key-features4.svg',
      title: 'Auto-Generated Reports & Documents',
      description:
        'Automate document generation, calculations, and routine tasks. Let the system do the heavy lifting so your team can focus on innovation and strategy.',
    },
    {
      icon: '/assets/document-templates/key-features5.svg',
      title: 'Pre-Configured Templates',
      description:
        'Let the system handle repetitive tasks like document creation and calculations. Save time and eliminate errors with automatically generated, accurate documents tailored to your needs.',
    },
    {
      icon: '/assets/document-templates/key-features6.svg',
      title: 'Work Anywhere, Anytime',
      description:
        'Whether you are in the office or on the move enjoy a seamless experience on any device. The platform adapts beautifully to smartphones, tablets, and desktops.',
    },
  ]

  return (
    <section id="features" className="key-features pad-60">
      <Container className="container">
        <Box className="text-center mb-5">
          <Typography
            variant="h2"
            className="text-white bold mb-2 fontWeight700"
            style={{ color: '#ffffff' }}
          >
            Key Features in Epoch7
          </Typography>

          <Typography
            style={{ color: '#ffffff' }}
            className="fontweight-bold font-size20 text-white"
          >
            Start taking control of your future today and
            <br />
            reach your full potential with goal tracking.
          </Typography>
        </Box>

        <Grid container spacing={4} className="box-list">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index} className=" mb-4 d-flex">
              <Box className="feature-box h-100 p-4 text-center">
                <Box component="img" className="mb-3" src={feature.icon} alt={feature.title} />
                <Typography variant="h6" className="mb-2">
                  {feature.title}
                </Typography>
                <Typography className="mb-0">{feature.description}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default KeyFeatures
